export function deg2rad(deg: number): number {
    return (deg * Math.PI) / 180
}

export function rad2deg(rad: number): number {
    return (rad * 180) / Math.PI
}

// wraps a value to the range [0, maxValue) including negative values
export function wrap(value: number, maxValue: number): number {
    if (maxValue <= 0) {
        throw Error("maxValue must be positive")
    }
    value = value % maxValue
    return value >= 0 ? value : value + maxValue
}

export function round(value: number, digits: number): number {
    return Math.round(value * digits * 10) / (digits * 10)
}
